import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { Stack, Container } from '@mui/material';

import { AuthGuard } from 'src/auth/guard';
import SuperadminGuard from 'src/auth/guard/superadmin-guard';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const ChatPage = lazy(() => import('src/pages/ai/chat'));

// ----------------------------------------------------------------------

export const aiRoutes = [
  {
    element: (
      <AuthGuard>
        <SuperadminGuard>
          <Container component="main">
            <Stack
              gap={2}
              sx={{
                py: 12,
                m: 'auto',
                maxWidth: 400,
                minHeight: '100vh',
                textAlign: 'center',
                justifyContent: 'center',
              }}
            >
              <Suspense fallback={<SplashScreen />}>
                <Outlet />
              </Suspense>
            </Stack>
          </Container>
        </SuperadminGuard>
      </AuthGuard>
    ),
    children: [
      {
        path: 'ai',
        children: [
          {
            index: true,
            element: <Navigate to="/ai/chat" replace />,
          },
          {
            path: 'chat',
            element: <ChatPage />,
            handle: {
              crumb: {
                i18nKey: 'nav.menu.ai.chat',
              },
            },
          },
        ],
      },
    ],
  },
];
